// ie polyfill
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'

import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control
import './utils/filter' // global filter
import { sysInfo } from '@/config'

import VideoPlayer from 'vue-video-player'
// vue-simple-uploader
import uploader from 'vue-simple-uploader'
import ZmComponentsLib from 'zm-components-lib'
import 'zm-components-lib/lib/styles/zm-components-lib.css'
import hls from 'videojs-contrib-hls'
// 滚动加载
import infiniteScroll from 'vue-infinite-scroll'
//  全局通用样式
import '@/assets/styles/common.less'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
// 挂载全局使用的方法
import VueDraggableResizable from 'vue-draggable-resizable'
Vue.component('vue-draggable-resizable', VueDraggableResizable)

// import ZmComponentsLib from 'zm-components-lib'
// Vue.use(ZmComponentsLib)
Vue.use(VideoPlayer)
Vue.use(uploader)
Vue.use(hls)
Vue.use(infiniteScroll)
Vue.use(ZmComponentsLib)

Vue.config.productionTip = false

// mount axios Vue.$http and this.$http

Vue.use(VueAxios)
Vue.prototype.$sysInfo = sysInfo
new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
